export default __webpack_public_path__ + "static/media/currencia.49175950.jpg";